import React from 'react';

import RelatedItemsSelection from '../../../form-components/related-items-selection';

export default ({
  // Data values
  relatedItems,
  setRelatedItems
}) => (
  <div>
    <RelatedItemsSelection
      selectedItems={relatedItems}
      onChange={setRelatedItems}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/new-item-form/stage-4/index.js